<template>
  <div v-if="valor === 0">
    <sidebar-menu-akahon 
      @search-input-emit="search"
    />
    <div class="main-content">
          <router-view/>
      </div>
  </div>




  <body class="bg-primary" v-else >
    
    <div id="layoutAuthentication" style="background: #ffffff">
      <div id="layoutAuthentication_content">
        <main>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <div class="card shadow-lg border-0 rounded-lg mt-5">
                  <div class="card-header">
                    <!--<h3 class="text-center font-weight-light my-4">&nbsp;</h3>--> 
                    
                    <img src="@/assets/farma-logo.png"
                    height="70"
                    width="280"
                  />
                  </div>
                  <div class="card-body" style="background: #ECF8EF">
                    <form>
                      <div class="form-floating mb-3">
                        <input
                          class="form-control"
                          id="inputEmail"
                          type="email"
                          v-model="usuario"
                          placeholder="Usuario"
                        />
                        <label for="inputEmail">Usuario</label>
                      </div>
                      <div class="form-floating mb-3">
                        <input
                          class="form-control"
                          id="inputPassword"
                          type="password"
                          placeholder="Password"
                          v-model="password"
                          @keyup.enter="login()" 
                        />
                        <label for="inputPassword">Contraseña</label>
                      </div>
                      <!--
                                            <div class="form-check mb-3">
                                                <input class="form-check-input" id="inputRememberPassword" type="checkbox" value="" />
                                                <label class="form-check-label" for="inputRememberPassword">Remember Password</label>
                                            </div>
                                            -->
                      <div
                        class="d-flex align-items-center justify-content-between mt-4 mb-0"
                      >
                        <!--<a class="small" href="password.html">Forgot Password?</a>-->
                        <a class="btn btn-outline-primary" @click="login()">Login</a>
                      </div>
                    </form>
                  </div>
                  <div class="card-footer text-center py-3">
                    <!--<div class="small"><a href="register.html">Need an account? Sign up!</a></div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <br />
        <br />
      </div>
    </div>
  </body>


</template>

<script>
import SidebarMenuAkahon from "@/components/Sidebar-menu-akahon.vue"
import axios from "axios";
import IPServie from "./views/service/ConectionDataService";
export default {
  name: "App",
  data(){
    return{
      http_: "",
      valor: 1,
      usuario: "",
      password: "",
      posicion: 1,
      tipoUser: "FARMAENLACE",
    }

  },
  components: {
    SidebarMenuAkahon,
  },
  methods: {
    search(val) {
      
    },
    async login() {
      let me = this;
      console.log("logeando");
      //this.$router.push('/dashboard');
      //this.valor = 0;
      var url = me.http_ + "/APIHC/users/loginU/"+me.usuario+"/"+me.password;
    
      await axios.get(url)
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);
          //console.log(respuesta.atribuciones.aplicacion.modulo);
          if (respuesta != "") {
            //localStorage.tokenhc = respuesta.token;
            me.valor = 0;
            localStorage.userhc = me.usuario;
            localStorage.rolhc = response.data.roluser;
            let date = new Date();
            let outputF =
              String(date.getDate()).padStart(2, "0") +
              "/" +
              String(date.getMonth() + 1).padStart(2, "0") +
              "/" +
              date.getFullYear();
            localStorage.fechahc = outputF;
            //me.cargarMenu();
          } else {
            me.valor = 1;
            me.posicion = 0;
          }
         
             
        })
        .catch(function (error) {
          console.log(error);
          console.log("respuesta..");
        });
     
        
      console.log("respuesta2..");
    },
    cargarMenu(){
      console.log("Ingresando a menu");
      //console.log(this.$router.push('/'));
      this.$router.push('/');
      console.log("saliendo de menu");
    },
    beforeDestroy() {
      localStorage.removeItem("user");
    },
    verificarSesion() {
      let me = this;
      me.usuario = localStorage.getItem("userhc");
      console.log("usuario activo: "+me.usuario);
      if (me.usuario != null) {
        console.log("Login")
        me.valor = 0;
        this.$router.push('/');
      } else {
        console.log("Principal")
        me.valor = 1;
        
      }
      console.log("Usurio actual: " + me.usuario);
    },
  },
  mounted() {
    let me = this;
    me.http_ = IPServie.getURL();
    me.verificarSesion();
  },

}
</script>

<style></style>

<style>
.main-content {
  padding: 1px 0px 1px 1px;
  margin-left: 1px;
  z-index: -1;
  min-height: 600px;
  color:#008DD2;
  
}
@media only screen and (max-width: 800px) {
  .main-content {
    margin-left: 0;
  }
}
</style> 


<style>
/* custom scrollbar */
::-webkit-scrollbar {
  width: 15px; /* tamaño del grosor  */
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 4px solid transparent; /* tamaño del borde a +++ es mas peq  */
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>
